import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Nav = styled.nav`
  @media (max-width: 768px) {
    position: relative;
  }
`;

const NavList = styled.ul`
  display: flex;
  gap: 2rem;
  list-style: none;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    flex-direction: column;
    position: absolute;
    top: 2.5rem;
    background: #fbfbec;
    gap: 1rem;
    width: 150px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    z-index: 200;
    display: ${props => (props.open ? 'flex' : 'none')};
  }
`;

const NavItem = styled.li`
  position: relative;
  a {
    position: relative;
    z-index: 1;
    text-decoration: none;
    color: #0d3462;
    font-weight: 500;
    transition: color 0.2s;
    overflow: hidden;
    display: inline-block;
  }
  .nav-link-text {
    position: relative;
    z-index: 2;
    display: inline-block;
  }
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100px;
    background:  #dc8861;
    z-index: 1;
    pointer-events: none;
    opacity: 0;
    transform: translateY(-100%);
    transition: transform 0.4s cubic-bezier(0.4,0,0.2,1), opacity 0.2s;
  }
  @media (max-width: 768px) {
    &::before {
      display: none;
    }
  }
  &:hover::before,
  &:focus-within::before {
    transform: translateY(-38px);
    opacity: 1;
  }
  a:hover,
  a:focus {
    color: #fbfbec;
  }
  a {
    /* Ensure text is above the sliding background */
    position: relative;
    z-index: 1;
  }
`;


const Hamburger = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  padding: 0;
  margin-left: 1rem;

  @media (max-width: 768px) {
    display: flex;
  }

  span {
    width: 25px;
    height: 3px;
    background: #2a2a2a;
    margin: 3px 0;
    border-radius: 2px;
    display: block;
  }
`;

const Navigation = ({ links }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  // Map href to translation key
  const navKey = href => {
    if (href === '/') return 'home';
    if (href === '/about') return 'about';
    //if (href === '/services') return 'services';
    if (href === '/contact') return 'contact';
    return href.replace('/', '');
  };

  return (
    <Nav aria-label="Main Navigation">
      <Hamburger
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open}
        aria-controls="nav-list"
        onClick={() => setOpen(o => !o)}
      >
        <span />
        <span />
        <span />
      </Hamburger>
      <NavList id="nav-list" open={open}>
        {links.map(link => (
          <NavItem key={link.href}>
            <Link to={link.href} onClick={() => setOpen(false)}><span className="nav-link-text">{t(`nav.${navKey(link.href)}`)}</span></Link>
          </NavItem>
        ))}
      </NavList>
    </Nav>
  );
};

Navigation.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Navigation;
